import { roles, applyLink, APPLY_EMAIL } from '../data/roles';
import { Link } from 'react-router-dom';
import { ArrowRight, Rocket, GraduationCap, Laptop, HeartHandshake, MapPin, Briefcase } from 'lucide-react';
import './JoinUs.css';

const perks = [
  { title: 'Work on real products', desc: 'Ship software used by colleges, organizations and communities, not throwaway demos.', icon: <Rocket /> },
  { title: 'Learn every day', desc: 'Work alongside experienced developers, get code reviews and grow into bigger responsibilities.', icon: <GraduationCap /> },
  { title: 'Flexible way of working', desc: 'Remote-friendly with a focus on outcomes rather than hours at a desk.', icon: <Laptop /> },
  { title: 'A supportive team', desc: 'Small team, honest feedback and room to own what you build.', icon: <HeartHandshake /> }
];

const JoinUs = () => (
  <>
    <title>Careers - Pidesk</title>
    <meta name="description" content="Join the Pidesk team. Build real products with developers, designers and creators." />

    <div className="careers-page">
      <div className="container">
        <div className="careers-hero">
          <span className="careers-eyebrow">Careers</span>
          <h1>Build things that matter with us</h1>
          <p>We're looking for passionate developers, designers and creators to build impactful technology.</p>
          <div className="careers-hero-actions">
            <a href="#roles" className="btn btn-primary btn-lg">See open roles</a>
            <a href={applyLink('General application')} className="btn btn-secondary btn-lg">Send your CV</a>
          </div>
        </div>

        <section className="careers-section">
          <h2>Why join Pidesk</h2>
          <div className="perk-grid">
            {perks.map((p) => (
              <div key={p.title} className="perk-card">
                <div className="perk-icon">{p.icon}</div>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="careers-section" id="roles">
          <h2>Open positions</h2>
          <div className="role-list">
            {roles.map((r) => (
              <Link key={r.slug} to={`/join/${r.slug}`} className="role-card">
                <div className="role-main">
                  <h3>{r.title}</h3>
                  <p>{r.short}</p>
                  <div className="role-meta">
                    <span><Briefcase size={14} /> {r.type}</span>
                    <span><MapPin size={14} /> {r.place}</span>
                  </div>
                </div>
                <span className="role-view">View details <ArrowRight size={16} /></span>
              </Link>
            ))}
          </div>
          <p className="careers-note">
            Don't see your role? Write to <a href={`mailto:${APPLY_EMAIL}`}>{APPLY_EMAIL}</a> and tell us how you'd like to contribute.
          </p>
        </section>

        <section className="careers-dcic">
          <div>
            <span className="careers-eyebrow">DCIC Community</span>
            <h2>Not ready for a full-time role?</h2>
            <p>Join the DCIC developer community to contribute to projects, take part in hackathons and learn together.</p>
          </div>
          <a href="https://dcic.pidesk.in" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg">
            Join DCIC <ArrowRight size={18} style={{ marginLeft: 8 }} />
          </a>
        </section>
      </div>
    </div>
  </>
);

export default JoinUs;
